<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow-lg h-auto flex flex-col items-center justify-center w-full p-6 relative"
  >
    <div class="flex justify-between items-center mb-6 w-full">
      <h3 class="text-xl font-bold dark:text-gray-200">Edit Profile</h3>
      <button
        @click="$emit('close')"
        class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form @submit.prevent="saveProfile" class="space-y-4 w-full">
      <div>
        <label class="block mb-2 text-sm font-medium dark:text-gray-300"
          >Full Name</label
        >
        <input
          v-model="formData.name"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-main-500 focus:border-main-500 dark:bg-gray-700 dark:text-white"
          required
        />
      </div>

      <div>
        <label class="block mb-2 text-sm font-medium dark:text-gray-300"
          >Email</label
        >
        <input
          v-model="formData.email"
          type="email"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-main-500 focus:border-main-500 dark:bg-gray-700 dark:text-white"
          required
        />
      </div>

      <div>
        <label class="block mb-2 text-sm font-medium dark:text-gray-300">
          About Me
        </label>
        <textarea
          v-model="formData.about"
          rows="3"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-main-500 focus:border-main-500 dark:bg-gray-700 dark:text-white resize-y"
          placeholder="Tell us about yourself"
        ></textarea>
      </div>

      <div class="flex gap-3 pt-4">
        <button
          type="button"
          @click="$emit('close')"
          class="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 py-2 px-4 rounded-lg transition dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
        >
          Cancel
        </button>
        <button
          type="submit"
          :disabled="loading"
          class="flex-1 bg-main-500 dark:bg-sub-700 hover:bg-main-600 dark:hover:bg-sub-900 text-white py-2 px-4 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin mr-2"></i> Saving...
          </span>
          <span v-else> Save Changes </span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  props: {
    profileData: {
      type: Object,
      default: () => ({
        name: "",
        email: "",
        about: "",
      }),
    },
  },
  data() {
    return {
      formData: { ...this.profileData },
      loading: false,
    };
  },
  methods: {
    async saveProfile() {
      this.loading = true;
      const result = await this.$store.dispatch(
        "updateUserProfile",
        this.formData
      );
      this.loading = false;
      if (result && result.success) {
        toast.success(result.message || "Profile updated successfully!");
        this.$emit("close");
      } else {
        toast.error(result?.error || "Failed to update profile.");
      }
    },
  },
};
</script>
